module.exports = __webpack_public_path__ + "static/media/next.e547caa3.svg";